export default __webpack_public_path__ + "static/media/upload-doc.a9338f8c.svg";